import React from 'react';

import { ArrowRightIcon } from 'modules/icons/ArrowRight';
import { useParams } from 'services/params';

import * as S from './Articles.style';
import * as T from './Articles.types';

export const Articles: React.FC<T.CasesdeSucessoContentCollection> = ({ items }) => {
  const params = useParams();
  return (
    <S.Articles className="section">
      <S.Container>
        <div className="content">
          {items
            .filter((item) => item.publicar)
            .map((item) => {
              return (
                <div key={item.title} className="card">
                  <a href={`/casesdesucesso${item.slug}${params}`}>
                    <figure>
                      <img src={item.thumb.url} alt={item.title} width={485} height={485} />
                    </figure>
                    <p>
                      <strong>{item.title}</strong>
                    </p>
                    <p>{item.description}</p>
                    <span>
                      Saiba mais
                      <ArrowRightIcon />
                    </span>
                  </a>
                </div>
              );
            })}
        </div>
      </S.Container>
    </S.Articles>
  );
};
